import { useContext } from "react";
import { EnvironmentContext } from "./EnvironmentContext.js";
const useEnvironment = () => {
  return useContext(EnvironmentContext);
};
export {
  useEnvironment
};
//# sourceMappingURL=useEnvironment.js.map
